import React from 'react';
import { useParams } from 'react-router-dom';
import { WorkspacesStore } from '../../DataSource/Stores/Cabinet/WorkspacesStore';
import { observer } from 'mobx-react';

interface ThemeProps {
  configs: {
    [key: string]: React.ReactNode;
  };
}

const Theme: React.FC<ThemeProps> = ({ configs }) => {
  const { id } = useParams<{ id: string | undefined }>();
  const currentWorkspace = WorkspacesStore.dataListWork.find((el) => el._id === id);

  // Логика выбора компонента на основе id
  let SelectedComponent;

  if (id === '66e170b52fc0a03d58789c24') {
    SelectedComponent = configs.order_management;
  } else if (id === '6707a212598d48bda5860bf0') {
    // Добавьте дополнительные проверки для других id
    SelectedComponent = configs.delivery_center;
  } else if (id === '67220912e6bd539b6a9143bd' || id === '69f9bbecc8e6087739573ec3') {
    // Добавьте дополнительные проверки для других id
    SelectedComponent = configs.order_management;
  } else if (id === '6732ed08a29f2065aeb56662') {
    SelectedComponent = configs.shokolatye_cex;
  } else if (id === '67220912e6bd539b6a9143bd') {
    SelectedComponent = configs.lanzhou_rev;
  } else if (id === '6720e7fa847708a28a16c731') {
    SelectedComponent = configs.meta_delivery;
  } else if (id === '67ef8a0d835120217b8c05d0') {
    SelectedComponent = configs.inventors;
  } else if (id === '680a0d7240d664b4503fa663') {
    SelectedComponent = configs.hotel;
  } else if (currentWorkspace && currentWorkspace.category === 'order_management') {
    SelectedComponent = configs.order_management;
  } else {
    return <div>Компонент не найден для id: {id}</div>;
  }

  return <>{SelectedComponent}</>;
};

export default observer(Theme);
